<template>
    <activation-brief-shipping-provider
        v-slot="{
        brief,
        contact,
        step,
        currentStep,
        isPreview,
        completeBrief,
        patchStep,
        goNextStep,
        goPreviousStep,
        isLoading,
        isCompletingBrief,
        loadingCountries,
        loadingProvinces,
        countries,
        provinces,
        countryUpdated,
        errors,
        errorMessage
    }">
        <activation-brief-shipping-view
            :brief="brief"
            :contact="contact"
            :is-preview="isPreview"
            :step="step"
            :countries="countries"
            :provinces="provinces"
            :current-step="currentStep"
            :is-loading="isLoading"
            :is-additional-order="isAdditionalOrder"
            :loading-countries="loadingCountries"
            :loading-provinces="loadingProvinces"
            :errors="errors"
            :error-message="errorMessage"
            @country-updated="countryUpdated"
            @go-next-step="goNextStep"
            @go-previous-step="goPreviousStep"
            @patch-step="patchStep"
            @chountry-updated="countryUpdated"
        />
    </activation-brief-shipping-provider>
</template>

<script>
    import ActivationBriefShippingView from "../data-views/activation-briefs/ActivationBriefShippingView";
    import ActivationBriefShippingProvider from "../providers/activation-brief-steps/ActivationBriefShippingProvider";

    export default {
        name: "ActivationBriefShippingRouterView",
        props: {
            isAdditionalOrder: {
                type: Boolean,
                default: false,
            }
        },
        components: {
            ActivationBriefShippingProvider,
            ActivationBriefShippingView,
        }
    }
</script>
